import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

import $ from 'jquery';
import 'react-phone-input-2/lib/material.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';

// ✅ MUI Theme setup
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme'; // Make sure this file exists

// ✅ Assign jQuery globally (after all imports)
window.jQuery = $;

// ✅ Wrap App in ThemeProvider
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </StrictMode>
);
